import React, {PureComponent} from 'react';
import classNames from 'classnames';

import MainHeader from 'lib/struct/headers/MainHeader';
import List from 'lib/struct/lists/List';
import Link from 'lib/struct/inlines/Link';
import svg from '../../img/bodysite-logo.svg';
import telegram from '../../img/telegram.svg';
import youtube from '../../img/youtube.svg';
import vk from '../../img/vk.svg';

import styles from './HeaderBar.less';

export default class HeaderBar extends PureComponent {
	state = {
		is_open_clean_modal: false
	};

	render() {
		const plugin_version = window.shop_productgroup.plugin_version;

		return (
			<div className={styles['header-bar']}>
				<div className={styles['header-bar__info']}>
					<MainHeader className={styles['header']}>Группы товаров
						<span className={styles['header__plugin-version']}>v.&nbsp; {plugin_version}</span>
					</MainHeader>
					<div className={styles['dev-block']}>
						<div className={styles['dev-block__item']}>
							<span className={styles['dev-block__label']}>Разработчик:</span>
							<Link href="https://bodysite.ru"
								target="_blank"
								className={styles['dev-block__icon-link']}>
								<img className={styles['bodysite-logo']}
									src={svg} />
							</Link>
						</div>
						<div className={styles['dev-block__item']}>
							<span className={styles['dev-block__label']}>Подписывайтесь:</span>
							<Link href="https://t.me/bodysite"
								target="_blank"
								className={styles['dev-block__icon-link']}>
								<img className={classNames(styles['dev-block__icon'], styles['icon24'])} src={telegram} />
							</Link>
							<Link href="https://www.youtube.com/channel/UCbPi3dch9M-lInwPiO4aMEQ"
								target="_blank" className={styles['dev-block__icon-link']}>
								<img className={classNames(styles['dev-block__icon'], styles['icon24'])} src={youtube} />
							</Link>
							<Link href="https://vk.com/bodysiteofficial"
								target="_blank" className={styles['dev-block__icon-link']}>
								<img className={classNames(styles['dev-block__icon'], styles['icon24'], styles['dev-block__icon_last'])} src={vk} />
							</Link>
						</div>
					</div>
				</div>
				<div className={styles['link-bar']}>
					<List className={styles['link-bar__list']} isHorizontal>
						<Link href="https://bodysite.ru/help/productgroup/manual/"
							target="_blank"
							icon={<span className={classNames(styles['icon16'], styles['help-icon'])}/>}
							className={styles['link-bar__link']}>
							Инструкции по настройке
						</Link>
						<Link href="https://bodysite.ru/help/productgroup/reports/"
							target="_blank"
							icon={<span className={classNames(styles['icon16'], styles['support-icon'])}/>}
							className={styles['link-bar__link']}>
							Сообщить об ошибке
						</Link>
						<Link href="https://bodysite.ru/help/productgroup/suggestions/"
							target="_blank"
							icon={<span className={classNames(styles['icon16'], styles['bulb-icon'])}/>}
							className={styles['link-bar__link']}>
							Предложить улучшение
						</Link>
						<Link href="https://www.webasyst.ru/store/plugin/shop/productgroup/reviews/"
							target="_blank"
							icon={<span className={classNames(styles['icon16'], styles['review-icon'])}/>}
							className={styles['link-bar__link']}>
							Оставить отзыв
						</Link>
					</List>
				</div>
			</div>
		);
	}
}